<script>
import { Pie } from 'vue-chartjs'
// const { reactiveProp } = mixins

import ChartDataLabels from 'chartjs-plugin-datalabels';



export default {
	extends: Pie,
	//mixins: [reactiveProp],
	props: {
		chartData: Object,
		options: Array
	},

	mounted () {
		// Options
		let options = {
			plugins: {
				datalabels: {
					display: 'auto',
					color: "black",
					textAlign: "center",
					font: {
						size: 13
					},

					labels: {
						value: {
							align: 'top',
							formatter: (value, ctx) => value,
						},

						percentage: {
							align: 'bottom',
							formatter: function(value, ctx) {
								let totalResponses = _.sum(ctx.dataset.data)
								return (Math.round((value / totalResponses) * 100)) + '%'
							},
						},
					}
				},
			}
		}

		this.addPlugin(ChartDataLabels);
		this.renderChart(this.chartData, options)
	}
}
</script>
